import { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { Button } from "../Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
type Props = {
  id?: string;
  className?: string;
  data: {
    message: string;
    toDate: string;
  } | null;
  onClose: () => void;
};

export function GameMaintenanceModal({
  id = "game-maintenance-modal",
  className = "",
  data,
  onClose,
}: Props) {
  const [remainingTime, setRemainingTime] = useState("");
  const timerRef = useRef<number | null>(null);

  useEffect(() => {
    if (!data) return;

    const endTime = new Date(data.toDate).getTime();

    timerRef.current = window.setInterval(() => {
      const now = Date.now();
      const diff = Math.max(0, Math.floor((endTime - now) / 1000));

      if (diff <= 0) {
        clearInterval(timerRef.current!);
        onClose();
        return;
      }

      const days = Math.floor(diff / 86400);
      const hours = Math.floor((diff % 86400) / 3600);
      const minutes = Math.floor((diff % 3600) / 60);
      const seconds = diff % 60;

      setRemainingTime(
        `${days} days, ${hours} hours, ${minutes} minutes, ${seconds} seconds`,
      );
    }, 1000);

    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
        timerRef.current = null;
      }
    };
  }, [data, onClose]);

  if (!data) return null;

  return createPortal(
    <div id={id} className={`fixed inset-0 z-[9999] bg-black/70 ${className}`}>
      <div
        className="fixed top-1/2 left-1/2 w-full max-w-[400px] px-4
                   -translate-x-1/2 -translate-y-1/2"
      >
        <div className="relative rounded-2xl bg-white p-6 text-center shadow-xl">
          <Button
            onClick={onClose}
            className="absolute top-4 right-4 h-6 w-6 rounded-full bg-[#F2F2F2] text-[#838383]"
          >
            <FontAwesomeIcon icon={faTimes} />
          </Button>
          {/* Icon */}
          <div className="relative mx-auto mb-4 h-[125px] w-[125px] flex items-center justify-center">
            <div className="absolute inset-0 rounded-full blur-[25px] bg-red-200" />
            <div
              className="relative z-10 flex h-[64px] w-[64px] items-center
                            justify-center rounded-full bg-white"
            >
              <img
                src="/icons/ic-info.svg"
                alt="Maintenance"
                className="h-[40px] w-[40px]"
              />
            </div>
          </div>

          {/* Content */}
          <h2 className="mb-2 text-lg font-semibold uppercase text-gray-800">
            Failed
          </h2>

          <p className="mb-3 text-sm text-gray-600">{data.message}</p>

          <p className="text-sm font-medium text-red-600">{remainingTime}</p>
        </div>
      </div>
    </div>,
    document.body,
  );
}
export const SHOW_MAINTENANCE_EVENT = "SHOW_MAINTENANCE_EVENT";

export type MaintenanceEventDetail = {
  message: string;
  toDate: string;
};
